import { render } from "./DaiwariFormattingNakatoji.vue?vue&type=template&id=0b82e9d2&scoped=true"
import script from "./DaiwariFormattingNakatoji.vue?vue&type=script&lang=js"
export * from "./DaiwariFormattingNakatoji.vue?vue&type=script&lang=js"

import "./DaiwariFormattingNakatoji.vue?vue&type=style&index=0&id=0b82e9d2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b82e9d2"]])

export default __exports__